import { render } from "./ProductSection.vue?vue&type=template&id=d0420e46&scoped=true"
import script from "./ProductSection.vue?vue&type=script&lang=js"
export * from "./ProductSection.vue?vue&type=script&lang=js"

import "./ProductSection.vue?vue&type=style&index=0&id=d0420e46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0420e46"]])

export default __exports__